import React, { Component, Fragment } from 'react';
import authService from '../api-authorization/AuthorizeService'
import { FormattedMessage } from 'react-intl';
import { Dialog, Transition } from '@headlessui/react';
import { ConfirmAlert } from '../controls/ConfirmAlert'
import { AuthorityModules, AuthorityActions } from '../api-authorization/ApiAuthorizationConstants';
import { BaseTextBox } from '../controls/BaseTextBox';
import Toast from '../controls/BaseToast'

export default class WidexSeriesViewDialog extends Component {
    constructor(props) {
        super(props);
        this.onClose = this.onClose.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleOnSubmit = this.handleOnSubmit.bind(this);
        this.state = { series: "", id: "", seriesOptions: [], deleteId: "", confirmOpen: false, isAllowCreate: false, isAllowEdit: false, isAllowDelete: false,errMessage:'' }
        this.populateListData = this.populateListData.bind(this);
        this.onConfirmClose = this.onConfirmClose.bind(this);
        this.deletedConfirm = this.deletedConfirm.bind(this);
        this.handleOnDeleted = this.handleOnDeleted.bind(this);
        this.handleOnEdit = this.handleOnEdit.bind(this);
    }

    async componentDidMount() {
        this.props.onRef(this);
        const create = await authService.isAllow(AuthorityModules.ProductOptions, AuthorityActions.Create);
        const edit = await authService.isAllow(AuthorityModules.ProductOptions, AuthorityActions.Edit);
        const del = await authService.isAllow(AuthorityModules.ProductOptions, AuthorityActions.Delete);
        this.setState({
            isAllowCreate: create, isAllowEdit: edit, isAllowDelete: del
        });
    }
    onChange(e) {
        const target = e.target;
        const value = target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });

    }
    deletedConfirm(id, e) {
        e.preventDefault();
        this.setState({ confirmOpen: true, deleteId: id });
    }
    onClose() {
        this.props.onClose();
        this.clearForm();
    }
    clearForm() {
        this.setState({
            series: "", id: "", errMessage:''
        });
    }
    async populateListData() {
        const token = await authService.getAccessToken();
        const response = await fetch('ProductOption/GetWidexSeriesOptions', {
            headers: !token ? {} : { 'Authorization': `${token}` }
        });
        const data = await response.json();
        this.setState({ seriesOptions: data.entities, pageCount: data.pageCount, totalCount: data.totalCount });
    }
    onConfirmClose() {
        this.setState({ confirmOpen: false, deleteId: null });
    }
    handleOnEdit(id, e) {
        e.preventDefault();
        const seriesOption = this.state.seriesOptions.filter(x => x.id == id)[0];
        this.setState({
            series: seriesOption.seriesType, id: seriesOption.id
        });
    }
    async handleOnSubmit(e) {
        e.preventDefault();
        var series = this.state.series.trim();
        var id = this.state.id;
        if (!series) {
            this.setState({ errMessage: 'Required' });
            return;
        }
        let response = null;
        const token = await authService.getAccessToken();
        if (id) {
            response = await fetch('ProductOption/EditWidexSeriesOption', {
                method: 'POST',
                headers: !token ? { 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json', 'Authorization': `${token}` },
                body: JSON.stringify({
                    'id': id,
                    'seriesType': series
                })
            })
        } else {
            response = await fetch('ProductOption/CreateWidexSeriesOption', {
                method: 'POST',
                headers: !token ? { 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json', 'Authorization': `${token}` },
                body: JSON.stringify({
                    'seriesType': series
                })
            })
        }
        if (response.status == 200) {
            let data = await response.json();
            if (data) {
                if (data.status == 0) {
                    this.clearForm();
                    this.populateListData();
                    this.props.populateListData();
                }
                else {
                    Toast.warn(data.message);

                }
            }
        }
        else {
            console.error('response.status:' + response.status)
        }
      
    }
    async handleOnDeleted(e) {
        e.preventDefault();
        var id = this.state.deleteId;
        if (!id) { return; }
        this.setState({
            seriesOptions: this.state.seriesOptions.filter((rec) => {
                return (rec.id != id);
            })
        });
        const token = await authService.getAccessToken();
        await fetch('ProductOption/DeleteWidexSeriesOption/' + id, {
            method: 'DELETE',
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json', 'Authorization': `${token}` }
        }).then(data => {
        });
        this.setState({ confirmOpen: false, deleteId: null });
    }
    render() {
        const open = this.props.open;
        return (
                <Transition.Root show={open} as={Fragment}>
                <Dialog
                    as="div"
                    static
                    className="fixed z-10 inset-0 overflow-y-auto"
                    open={open}
                    onClose={this.onClose}
                >
                    <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                        </Transition.Child>

                        {/* This element is to trick the browser into centering the modal contents. */}
                        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
                            &#8203;
          </span>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <form onSubmit={this.handleOnSubmit} style={{ width: '100vw' }}>
                                <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 border-b border-gray-200">
                                        <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                            <Dialog.Title as="h3" className="text-lg leading-6 font-semibold text-gray-900"><FormattedMessage id="SeriesManage" /></Dialog.Title>
                                        </div>
                                    </div>
                                    <div className="px-14 pt-6 pb-10 space-y-6">
                                        <div className="mt-0 flex">
                                            <label className="w-16 place-self-center block text-sm font-medium text-gray-700"><FormattedMessage id="Name" /></label>
                                            <BaseTextBox classnames="" type="text" name="series" placeholder="" value={this.state.series} onChange={this.onChange} errmessage={this.state.errMessage} />

                                            <button
                                                type="submit"
                                                className="flex-none ml-1 px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-l-md text-white bg-indigo-600"><FormattedMessage id="Save" /></button>
                                            <button
                                                type="button"
                                                className="flex-none rounded-r-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none sm:mt-0  sm:text-sm" onClick={this.onClose}><FormattedMessage id="Cancel" /></button>
                                        </div>
                                        <div className="mt-3 h-60 overflow-y-auto">
                                            <table className='w-full'>
                                                <thead>
                                                    <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800">
                                                        <th className="px-4 py-3"><FormattedMessage id="CustomeMadeSeries" /></th>
                                                        <th className="px-4 py-3"><FormattedMessage id="Actions" /></th>
                                                    </tr>
                                                </thead>
                                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800">
                                                    {this.state.seriesOptions.map((item, index) => {
                                                        return (
                                                            <tr key={index} className="bg-gra-50 hover:bg-gray-100 text-gray-700 dark:text-gray-400">
                                                                <td className="px-4 py-3 text-sm">{item.seriesType}</td>
                                                                <td className="px-4 py-3 text-sm">
                                                                    {this.state.isAllowEdit && <a className="text-indigo-600 hover:text-indigo-900" href="#" onClick={(e) => this.handleOnEdit(item.id, e)}><FormattedMessage id="edit" /></a>}
                                                                    {this.state.isAllowDelete && <span>|<a className="text-indigo-600 hover:text-indigo-900" href="#" onClick={(e) => this.deletedConfirm(item.id, e)}><FormattedMessage id="delete" /></a></span>}
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </form>
                         
                        </Transition.Child>
                        </div>
                        <ConfirmAlert onRef={(ref) => { this.confirmRef = ref }} onCancel={this.onConfirmClose} onOk={(e) => { this.handleOnDeleted(e) }} open={this.state.confirmOpen} />
                </Dialog>

            </Transition.Root >
        )
    }
}